export default __webpack_public_path__ + "static/media/hbs-bpk-banner-2.22d4a12f.jpg";